import { YHModal } from "@/components/YHModal";
import { RouterParamType } from "@/model/navModel";
import React, { useState, useEffect, FC } from "react";
import { useOfferDetailModel } from "./offerDetailModel";
import logo_pdf from "@/assets/images/logo_pdf.png";
import { exportPDF } from "@/utils/exportPDF";
import { offerService } from "../../offerService";
import { IOfferDetail, IOfferMaterialDetail } from "../../offerTypes";
import { customerService } from "@/views/base/customer/customerService";
import { useDictModel } from "@/views/base/dict/dictModel";
import { mdmService } from "@/views/public/mdmService";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { formatNum } from "@/utils/utils";
import { useOfferModel } from "../../offerModel";
export const OfferPdfDialog: FC<RouterParamType> = ({ id, mode }) => {
    const { offerPdfDialog: visible, setOfferPdfDialog, materialExport } = useOfferDetailModel(({ offerPdfDialog }) => [offerPdfDialog]);
    const { getTreeNodeName, getTreeNodeValue, getTreeNodeNameEn } = useDictModel(() => []);
    const [formVal, setFormVal] = useState<IOfferDetail | null>(null);
    const [list, setList] = useState<IOfferMaterialDetail[]>([]);
    const [customerInfo, setCustomerInfo] = useState<any>({});
    const [beInfo, setBeInfo] = useState<any>({});
    const [addInfo, setAddInfo] = useState<any>({});
    const { dataSource } = useOfferModel();
    useEffect(() => {
        if (visible) {
            //传过来的是code 把code转为id
            let i = dataSource.find(item => item.code === id)?.id
            getOfferDetailOne(i as string)
        }
    }, [visible])

    const onCancel = () => {
        setOfferPdfDialog(false);
    };

    //获取一条数据
    const getOfferDetailOne = async (id: string) => {
        let { retData } = await offerService.one(id);
        let { details, detailsAdd, ...formVal } = retData;
        if (retData) {
            //查询客户
            if (formVal.customerId) {
                let { retData: custData } = await customerService.one(formVal.customerId as string);
                setCustomerInfo(custData ?? {});
            }
            //查询实体
            if (formVal.bentityCode) {
                let { retData: beData } = await mdmService.getMdmBeOne(formVal.bentityCode as string);
                setBeInfo(beData ?? {})
            }
            setFormVal(formVal)
            setList(details ?? [])
            //在合同总金额上面加一行，显示海运费金额
            if (formVal.clause === DictCodeEnmu.TRADE_CFR || formVal.clause === DictCodeEnmu.TRADE_CLF) {
                setAddInfo(detailsAdd?.find(item => (item.name ?? "").indexOf("海运费") > -1) ?? {})
            }
        }
    };

    return <YHModal
        visible={visible}
        okText="确认导出"
        cancelText="关闭"
        onOk={() => {
            exportPDF("报价单", "offer_pdf", () => {
                materialExport();
            })
        }}
        onCancel={onCancel}
        title="报价单pdf样式预览"
        width={1200}
        bodyHeight={700}
        showFooter={true}
    >

        {formVal && <div id="offer_pdf">
            <header>
                <div className="logo">
                    <img src={logo_pdf} alt="" />
                </div>
                <div>
                    <h3>云湖春煜（天津）资产管理有限公司</h3>
                    <h4>YUN HU CHUN YU(TIANJIN) ASSETS MANAGEMENT CO.,LTD</h4>
                </div>
            </header>
            <ul className="description">
                <li>Add：{beInfo.address}</li>
                {/* <li>地址：天津市津南经济开发区旺港路１５号  </li> */}
                <li>Tianjin：{beInfo.postcode}</li>
                {/* <li>邮编：300350</li> */}
                <li>Tel.：{beInfo.phone}</li>
                {/* <li>电话： +86-22-28577398</li> */}
                <li>Fax：{beInfo.faxes}</li>
                {/* <li>传真： +86-22-28577398 </li> */}
                <li>Email：{beInfo.mailbox}</li>
                {/* <li>邮箱:</li> */}
                <li>Contact： {formVal.createUser}</li>
                {/* <li>联系人:</li> */}
            </ul>
            <div className="title">报价单 QUOTATION</div>
            <ul className="order_info">
                <li className="w70">
                    <div>编号 ：{formVal.code}</div>
                    <div>No.</div>
                </li>
                <li className="w30">
                    <div>日期 ：{`${formVal.offerTime ?? ""}`.substring(0, 10)}</div>
                    <div>Date</div>
                </li>
                {/* <li className="">
                    <div>客户信息：{formVal.customerName}</div>
                    <div>Information</div>
                </li> */}
                <li className="">
                    <div>公司名称：{customerInfo.name ?? ""}</div>
                    <div>Company Name</div>
                </li>
                <li className="">
                    <div>公司地址：{customerInfo.address ?? ""}</div>
                    <div>Company Address</div>
                </li>
                <li className="">
                    <div>联系人：{formVal.contact}</div>
                    <div>Contact</div>
                </li>
                <li className="">
                    <div>电话/传真/电邮：{formVal.phone}</div>
                    <div>Tel/Fax/E-mail</div>
                </li>
            </ul>
            <table className="material_table">
                <tbody>
                    <tr>
                        <td>
                            <div>货物名称</div>
                            <div>Name</div>
                        </td>
                        <td>
                            <div>货物规格与描述</div>
                            <div>Specification and description of goods</div>
                        </td>
                        <td>
                            <div>数量</div>
                            <div>QTY</div>
                        </td>
                        <td>
                            <div>单位</div>
                            <div>UNIT</div>
                        </td>
                        <td>
                            <div>单价（{formVal.currencyName}）</div>
                            <div>Unit Price（{getTreeNodeValue(formVal.currencyCode)}）</div>
                        </td>
                        <td>
                            <div>总价（{formVal.currencyName}）</div>
                            <div>Total Price({getTreeNodeValue(formVal.currencyCode)})</div>
                        </td>
                        <td>
                            <div>备注</div>
                            <div>Note</div>
                        </td>
                    </tr>
                    {list.map(item => (
                        <tr key={item.id}>
                            <td>
                                <span>{item.materialName}</span>
                                <br />
                                <span>{item.materialEname}</span>
                            </td>
                            <td>{item.model}</td>
                            <td>{item.num}</td>
                            <td>
                                <span>{item.unitName}</span>
                                <br />
                                <span>{getTreeNodeNameEn(item.unitCode)}</span>
                            </td>
                            <td>{formatNum(item.tradePrice)}</td>
                            <td>{formatNum(item.tradeAmount)}</td>
                            <td>{item.note}</td>
                        </tr>
                    ))}

                    {addInfo.id && <tr>
                        <td colSpan={7}>
                            <div>{addInfo.name}：{getTreeNodeValue(formVal.currencyCode)} {formatNum(addInfo.amount)}</div>
                            <div>{addInfo.ename}</div>
                        </td>
                    </tr>}
                    <tr>
                        <td colSpan={7}>
                            <div>合计总金额：{getTreeNodeValue(formVal.currencyCode)} {formatNum(formVal.contractAmount)}</div>
                            <div>Amount Amount</div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={7}>
                            <div>价格条款：{getTreeNodeName(formVal.clause)}</div>
                            <div>price clause</div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={7}>
                            <div>付款方式：{getTreeNodeName(formVal.detailsPayment?.[0]?.paymentMethod ?? "")}</div>
                            <div>Terms of Payment</div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={7}>
                            <div>报价有效期：{`${formVal.offerTime ?? ""}`.substring(0, 10)}</div>
                            <div>Validity Date</div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>}
    </YHModal>
}